import React from 'react';

export interface SideMenuItem {
  id: string;
  label: string;
  href: string;
}

export interface SideMenuProps {
  children?: React.ReactNode;
  items: SideMenuItem[];
  activeId?: string;
  navigationTitle?: string;
  className?: string;
  /** Extra classes applied to each list item (e.g. border token differences). */
  itemClassName?: string;
}

const SideMenu: React.FC<SideMenuProps> = ({
  items,
  activeId,
  navigationTitle,
  className = '',
  itemClassName = 'border-neutral-400',
}) => {
  const navLabelId = 'side-menu-heading';

  return (
    <nav
      className={`my-32 lg:col-span-2 ${className}`}
      aria-labelledby={navigationTitle ? navLabelId : undefined}
      aria-label={!navigationTitle ? 'Page navigation' : undefined}
      data-testid="atom-side-menu"
    >
      {navigationTitle && (
        <h2 id={navLabelId} className="pb-5 text-left font-body text-28 leading-normal">
          {navigationTitle}
        </h2>
      )}
      <ul className="sticky top-150 text-base font-medium" role="list">
        {items.map((item) => (
          <li
            key={item.id}
            className={`border-b py-10 ${itemClassName} ${activeId === item.id ? 'active' : ''}`}
          >
            <a
              href={item.href}
              aria-current={activeId === item.id ? 'true' : undefined}
              data-testid={`atom-side-menu-item-${item.id}`}
            >
              {item.label}
            </a>
          </li>
        ))}
      </ul>
    </nav>
  );
};

export default SideMenu;
